var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { elementOpen, elementClose, elementVoid, patch, text, } from 'incremental-dom';
import { packageVersion } from './version';
// NICE: Store e-mail address in localstorage and populate automatically ?
// NICE: Show 'please complete all fields' notice if partially complete and delay
// NICE: Include a 'clear' button
// Should stores be cleared on navigation?
import { JSXFactory } from '@appzuka/rxnano';
import { BehaviorSubject } from 'rxjs';
import { fromEvent } from 'rxjs';
import { combineLatest } from 'rxjs';
import * as uuidv1 from 'uuid/v1';
import { takeUntil } from 'rxjs/operators';
import './contactform.scss';
var formData = new BehaviorSubject({ email: '', subject: '', message: '' });
var emailSubject = new BehaviorSubject(false);
var subjectSubject = new BehaviorSubject(false);
var messageSubject = new BehaviorSubject(false);
var submitObserver = combineLatest(emailSubject, subjectSubject, messageSubject).pipe(
// tap(v => console.log(v))
);
var submitInput = function (pageChangeObservable, options) {
    var el = elementOpen('input', null, ['type', 'submit', 'value', 'Submit']);
    elementClose('input');
    submitObserver
        .pipe(takeUntil(pageChangeObservable))
        .subscribe(function (v) {
        if (v.reduce(function (a, c) { return a && c; }, true)) {
            // if (true) {
            el.removeAttribute('disabled');
            el.style.backgroundColor = options.highlight;
        }
        else {
            el.setAttribute('disabled', 'disabled');
            el.style.backgroundColor = '';
        }
    });
};
var emailInput = function (pageChangeObservable, label, options) {
    elementOpen('div', null, ['class', 'input-element']);
    var el = elementVoid('input', null, ['type', 'email']);
    var labelel = elementOpen('p', null, ['class', 'input-label']);
    text(label);
    elementOpen('span', null);
    text('You must enter a valid email address');
    elementClose('span');
    elementClose('p');
    elementClose('div');
    el.style.borderBottomColor = options.highlight;
    var source = fromEvent(el, 'input');
    var inputBlur = fromEvent(el, 'blur');
    var validInput = function () { return el.value.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) !== null; };
    // NICE: better to use pagechangeobservable to unsubscribe when the page changes
    source
        .pipe(takeUntil(pageChangeObservable))
        .subscribe(function () {
        if (el.value.length > 0) {
            labelel.classList.add("input-non-empty");
        }
        else {
            labelel.classList.remove("input-non-empty");
        }
    });
    inputBlur
        .pipe(takeUntil(pageChangeObservable))
        .subscribe(function () {
        if (validInput()) {
            el.style.backgroundColor = '';
            emailSubject.next(true);
            labelel.classList.remove('input-invalid');
        }
        else {
            el.style.backgroundColor = 'rgba(255, 100, 100, 0.2)';
            emailSubject.next(false);
            labelel.classList.add('input-invalid');
        }
    });
    formData
        .pipe(takeUntil(pageChangeObservable))
        .subscribe(function (data) {
        el.value = data.email;
        if (data.email.length > 0) {
            labelel.classList.add("input-non-empty");
        }
        else {
            labelel.classList.remove("input-non-empty");
        }
    });
    source
        .pipe(takeUntil(pageChangeObservable))
        .subscribe(function () {
        if (validInput()) {
            el.style.backgroundColor = '';
            labelel.classList.remove('input-invalid');
            emailSubject.next(true);
        }
        else {
            emailSubject.next(false);
        }
        formData.next(__assign(__assign({}, formData.value), { email: el.value }));
    });
};
var subjectInput = function (pageChangeObservable, label, options) {
    elementOpen('div', null, ['class', 'input-element']);
    var labelel = elementOpen('p', null, ['class', 'input-label']);
    text(label);
    elementClose('p');
    var el = elementVoid('input', null, ['type', 'text']);
    elementClose('div');
    el.style.borderBottomColor = options.highlight;
    var source = fromEvent(el, 'input');
    var inputBlur = fromEvent(el, 'blur');
    formData
        .pipe(takeUntil(pageChangeObservable))
        .subscribe(function (data) {
        el.value = data.subject;
        if (data.subject.length > 0) {
            labelel.classList.add("input-non-empty");
        }
        else {
            labelel.classList.remove("input-non-empty");
        }
    });
    inputBlur
        .pipe(takeUntil(pageChangeObservable))
        .subscribe(function () {
        if (el.value.length > 0) {
            el.style.backgroundColor = '';
            subjectSubject.next(true);
            labelel.classList.add("input-non-empty");
        }
        else {
            el.style.backgroundColor = 'rgba(255, 100, 100, 0.2)';
            subjectSubject.next(false);
            labelel.classList.remove("input-non-empty");
        }
    });
    source.subscribe(function () {
        if (el.value.length > 0) {
            el.style.backgroundColor = '';
            subjectSubject.next(true);
            labelel.classList.add("input-non-empty");
        }
        else {
            el.style.backgroundColor = 'rgba(255, 100, 100, 0.2)';
            subjectSubject.next(false);
            labelel.classList.remove("input-non-empty");
        }
        formData.next(__assign(__assign({}, formData.value), { subject: el.value }));
    });
};
var messageInput = function (pageChangeObservable, label, options) {
    elementOpen('div', null, ['class', 'input-element']);
    var labelel = elementOpen('p', null, ['class', 'input-label']);
    text(label);
    elementClose('p');
    var el = elementVoid('textarea', null, ['rows', '5']);
    elementClose('div');
    el.style.borderBottomColor = options.highlight;
    var source = fromEvent(el, 'input');
    var inputBlur = fromEvent(el, 'blur');
    formData
        .pipe(takeUntil(pageChangeObservable))
        .subscribe(function (data) {
        el.value = data.message;
        if (data.message.length > 0) {
            labelel.classList.add("input-non-empty");
        }
        else {
            labelel.classList.remove("input-non-empty");
        }
    });
    inputBlur
        .pipe(takeUntil(pageChangeObservable))
        .subscribe(function () {
        if (el.value.length > 0) {
            el.style.backgroundColor = '';
            subjectSubject.next(true);
            labelel.classList.add("input-non-empty");
        }
        else {
            el.style.backgroundColor = 'rgba(255, 100, 100, 0.2)';
            subjectSubject.next(false);
            labelel.classList.remove("input-non-empty");
        }
    });
    source.subscribe(function () {
        if (el.value.length > 0) {
            el.style.backgroundColor = '';
            messageSubject.next(true);
            labelel.classList.add("input-non-empty");
        }
        else {
            el.style.backgroundColor = 'rgba(255, 100, 100, 0.2)';
            messageSubject.next(false);
            labelel.classList.remove("input-non-empty");
        }
        formData.next(__assign(__assign({}, formData.value), { message: el.value }));
    });
};
var httpGet = function (url, payload) { return new Promise(function (resolve, reject) {
    // TODO: Implement online check (or before submit enabled)
    var xhr = new XMLHttpRequest();
    xhr.open('POST', url, true);
    // xhr.withCredentials = true;
    // If any headers are set CORS makes an OPTIONS request.  We do not need CORS for fullpixlist.json so we will bypass this
    // xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.setRequestHeader('Content-Type', 'application/json');
    // xhr.withCredentials = false;
    xhr.onload = function () {
        if (xhr.readyState === 4) {
            if (xhr.status === 200 || (xhr.status === 0 && xhr.responseText !== '')) {
                resolve({
                    status: 200,
                    body: xhr.responseText || ''
                });
            }
            else {
                resolve({
                    status: xhr.status,
                    body: xhr.responseText || ''
                });
            }
        }
    };
    xhr.onerror = function () {
        resolve({
            status: xhr.status,
            body: 'Network Error'
        });
    };
    xhr.send(JSON.stringify(payload));
    console.log('sent');
}); };
var submitSuccess = function (submittedMessage, submitDate) {
    JSXFactory.createElement("render", null,
        JSXFactory.createElement("p", { class: "submit-ok" }, "Message Successfully Submitted"),
        JSXFactory.createElement("p", { class: "submit-message" }, "Your message has been logged and we will respond to you as soon as possible."),
        JSXFactory.createElement("div", { class: "result-table" },
            JSXFactory.createElement("p", null, "Date:"),
            JSXFactory.createElement("p", null, submitDate),
            JSXFactory.createElement("p", null, "email:"),
            JSXFactory.createElement("p", null, submittedMessage.email),
            JSXFactory.createElement("p", null, "Subject:"),
            JSXFactory.createElement("p", null, submittedMessage.subject),
            JSXFactory.createElement("p", null, "Message:"),
            JSXFactory.createElement("p", null, submittedMessage.message)),
        JSXFactory.createElement("p", { class: "message-id" },
            "ID: ",
            submittedMessage.uuid),
        submittedMessage.testMode ? JSXFactory.createElement("p", { class: "test-warning" }, "System is in test mode: Message not submitted.") : '');
};
var submitPending = function (submittedMessage) {
    JSXFactory.createElement("render", null,
        JSXFactory.createElement("p", { class: "submit-pending" }, "Message Submitting ..."),
        JSXFactory.createElement("p", { class: "submit-message" }, "Please wait for confirmation of successful submission."),
        JSXFactory.createElement("div", { class: "result-table" },
            JSXFactory.createElement("p", null, "Date:"),
            JSXFactory.createElement("p", null, new Date().toLocaleString(undefined, { timeZone: 'Europe/London' })),
            JSXFactory.createElement("p", null, "email:"),
            JSXFactory.createElement("p", null, submittedMessage.email),
            JSXFactory.createElement("p", null, "Subject:"),
            JSXFactory.createElement("p", null, submittedMessage.subject),
            JSXFactory.createElement("p", null, "Message:"),
            JSXFactory.createElement("p", null, submittedMessage.message)),
        submittedMessage.testMode ? JSXFactory.createElement("p", { class: "test-warning" }, "System is in test mode: Message will not be submitted.") : '');
};
var submitFailed = function (submittedMessage, reason, options) {
    JSXFactory.createElement("render", null,
        JSXFactory.createElement("p", { class: "submit-failed" },
            "Message Submission Failed: ",
            reason),
        JSXFactory.createElement("p", { class: "submit-message" }, "Your message was not received due to a system error.  Please try again later."),
        JSXFactory.createElement("div", { class: "result-table" },
            JSXFactory.createElement("p", null, "Date:"),
            JSXFactory.createElement("p", null, new Date().toLocaleString(undefined, { timeZone: 'Europe/London' })),
            JSXFactory.createElement("p", null, "email:"),
            JSXFactory.createElement("p", null, submittedMessage.email),
            JSXFactory.createElement("p", null, "Subject:"),
            JSXFactory.createElement("p", null, submittedMessage.subject),
            JSXFactory.createElement("p", null, "Message:"),
            JSXFactory.createElement("p", null, submittedMessage.message)),
        JSXFactory.createElement("p", { class: "resubmit-button", style: "background-color: " + options.highlight, onclick: function () { return resubmit(submittedMessage, options); } }, "Resubmit"),
        submittedMessage.testMode ? JSXFactory.createElement("p", { class: "test-warning" }, "System is in test mode.") : '');
};
var resubmit = function (submittedMessage, options) {
    console.log('resubmitting');
    var el = document.getElementById('submitted-message');
    patch(el, function () { return submitPending(submittedMessage); });
    var payload = {
        "site": submittedMessage.sourceSite,
        "from": submittedMessage.email,
        "subject": submittedMessage.subject,
        "message": submittedMessage.message,
        "commit": options.commitVersion,
        "uuid": submittedMessage.uuid,
        "testMode": submittedMessage.testMode
    };
    // NICE: Implement promise timeout and retry poll using uuid
    httpGet('https://g06bpdkpw1.execute-api.eu-west-2.amazonaws.com/prod', payload).then(function (v) {
        if (v.status === 200) {
            var responseBody_1 = JSON.parse(v.body);
            var el_1 = document.getElementById('submitted-message');
            patch(el_1, function () { return submitSuccess(submittedMessage, responseBody_1.date); });
        }
        else {
            var el_2 = document.getElementById('submitted-message');
            patch(el_2, function () { return submitFailed(submittedMessage, "System Error: " + v.status, options); });
        }
    });
};
var submitForm = function (e, options) {
    e.preventDefault();
    var submittedMessage = Object.assign(formData.value, { uuid: uuidv1(), options: options });
    var el = document.getElementById('submitted-message');
    patch(el, function () { return submitPending(submittedMessage); });
    var payload = {
        "site": options.sourceSite,
        "from": submittedMessage.email,
        "subject": submittedMessage.subject,
        "message": submittedMessage.message,
        "commit": options.commitVersion,
        "uuid": submittedMessage.uuid,
        "testMode": submittedMessage.options.testMode
    };
    // NICE: Implement promise timeout and retry poll using uuid
    httpGet('https://g06bpdkpw1.execute-api.eu-west-2.amazonaws.com/prod', payload).then(function (v) {
        if (v.status === 200) {
            var responseBody_2 = JSON.parse(v.body);
            var el_3 = document.getElementById('submitted-message');
            patch(el_3, function () { return submitSuccess(submittedMessage, responseBody_2.date); });
        }
        else {
            console.log(v);
            var el_4 = document.getElementById('submitted-message');
            patch(el_4, function () { return submitFailed(submittedMessage, "System Error: " + v.status, options); });
        }
    });
    console.log('clearing');
    formData.next({ email: submittedMessage.email, subject: '', message: '' });
    emailSubject.next(true);
    subjectSubject.next(false);
    messageSubject.next(false);
    return false;
};
var contactForm = function (pageChangeObservable, options) {
    JSXFactory.createElement("render", null,
        JSXFactory.createElement("div", { class: 'form-wrapper' },
            JSXFactory.createElement("h2", null, "Contact Form"),
            JSXFactory.createElement("form", { onsubmit: function (e) { return submitForm(e, options); } },
                function () { return emailInput(pageChangeObservable, 'email', options); },
                JSXFactory.createElement("p", { class: "privacy-note" }, "Your email address will be used only to contact you in connection with this request and will not be shared with third parties."),
                function () { return subjectInput(pageChangeObservable, 'subject', options); },
                function () { return messageInput(pageChangeObservable, 'message', options); },
                JSXFactory.createElement("div", { class: "submit-area" },
                    function () { return submitInput(pageChangeObservable, options); },
                    JSXFactory.createElement("p", { class: "privacy-note" },
                        "By submitting your details, you agree to this site's terms and the processing of your data in accordance with our ",
                        JSXFactory.createElement("a", { target: "_blank", href: '/policies/privacy' }, "privacy policy."))),
                options.testMode ? JSXFactory.createElement("p", { class: "test-warning" }, "System is in test mode.  Messages will not be submitted.") : ''),
            JSXFactory.createElement("div", { id: "submitted-message" })));
};
export { contactForm, packageVersion };
//# sourceMappingURL=index.js.map